import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { useTheme } from '../../context/theme'
import {
  DMPrimaryButton,
  DMPrimaryAltButton,
  DMModal
} from '@decormatters/dm-theme'
import { setModalClose } from '../../redux/designerReducers/designerReducer'

import ModalContentContainer from './ModalContentContainer'
import ModalActionContainer from './ModalActionContainer'
import useModal from '../../hooks/useModal'
import useEnterKey from '../../hooks/useEnterKey'
import { ASSET_URL } from '../../constants/ApiEndpoints'

const MemberBadge = styled.img`
  width: 75px;
  height: 75px;
  padding-right: 8px;
`

const ModalBody = styled.div`
  font-size: 14px;
  text-align: center;
  margin-top: 18px;
  padding: 0 20px;
`

const MyRoomMaxedModal = ({ show, count = 0, onClose, onUpgrade }) => {
  const dispatch = useDispatch()
  const { appearance } = useTheme()
  const enter = useEnterKey()
  useModal(show)

  useEffect(() => {
    if (enter) {
      dispatch(setModalClose())
      if (show === true && onUpgrade) onUpgrade()
    }
  }, [enter, dispatch, onUpgrade, show])

  return (
    <DMModal show={show} scheme={appearance} onClose={onClose} maxWidth={350}>
      <ModalContentContainer>
        <MemberBadge src={ASSET_URL + 'designer/badge_membership_on.png'} />
        <ModalBody>
          <b>Upgrade to a membership</b> to unlock{' '}
          <b>unlimited image upload space.</b>
          {/*You have reached the max({count}) allowed images. Try deleting existing images or <b>upgrade to a memebership</b> to unlock <b>unlimited image upload space.</b>*/}
        </ModalBody>
        <ModalActionContainer>
          <DMPrimaryAltButton
            scheme={appearance}
            type="button"
            onClick={onClose}
            style={{ marginRight: '10px' }}
          >
            Cancel
          </DMPrimaryAltButton>
          <DMPrimaryButton
            scheme={appearance}
            type="button"
            onClick={onUpgrade}
            style={{ marginLeft: '10px' }}
          >
            Upgrade
          </DMPrimaryButton>
        </ModalActionContainer>
      </ModalContentContainer>
    </DMModal>
  )
}

export default MyRoomMaxedModal
